export default "__VITE_ASSET__bTsfuKLE__"